export default __webpack_public_path__ + "static/23-07cfad418b0bf64272a0cd0be4fea5c9.png";